export default __webpack_public_path__ + "static/media/bg-talk-3.f6b061ae.png";